module.exports = "<div class=\"videogular-container\">\r\n    <videogular>\r\n        <vg-media vg-src=\"$ctrl.config.sources\" vg-native-controls=\"true\"></vg-media>\r\n    </videogular>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/video-player/video-player.component.html
// module id = 580
// module chunks = 0